import { useEffect } from 'react'

/**
 * Shows the browser's native "leave site?" prompt on close, refresh or external navigation
 * while a routed form holds unsaved changes. Pass a reliable dirty flag (for seeded forms,
 * use useDirtyBaseline rather than formik.dirty).
 *
 * In-app route changes are NOT covered: the app mounts its routes under <BrowserRouter>
 * (App.tsx), and react-router's useBlocker only works inside a data router
 * (createBrowserRouter / RouterProvider), so it would throw here. Moving the app onto a
 * data router is the prerequisite for blocking in-app navigation with the same confirm.
 */
export const useUnsavedChangesWarning = (isDirty: boolean): void => {
  useEffect(() => {
    if (!isDirty) return
    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      // Chrome ignores preventDefault alone; returnValue must be set for the prompt to show.
      event.returnValue = ''
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [isDirty])
}
